module.exports = __webpack_public_path__ + "static/media/hot-tub.4ce2d338.svg";